import { render, staticRenderFns } from "./TenantTermsAndConditions.vue?vue&type=template&id=cc384a68&scoped=true&"
import script from "./TenantTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TenantTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./TenantTermsAndConditions.vue?vue&type=style&index=0&id=cc384a68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc384a68",
  null
  
)

export default component.exports